import { createSlice } from '@reduxjs/toolkit'

export const processFirstContactNotification = createSlice({
  name: 'FirstContactNotification',
  initialState: {
    notifications: {},
  },
  reducers: {
    saveNotification: (state, action) => {
      // let temp = [...state.notifications]
      let bulk_id = action.payload.id
      state.notifications[bulk_id] = action.payload
    },
    clearAllNotification: (state, action) => {
      state.notifications = {}
    },
    clearNotification: (state, action) => {},
    clearNotifications: (state, action) => {},
  },
})

export const {
  saveNotification,
  clearAllNotification,
  clearNotification,
  clearNotifications,
} = processFirstContactNotification.actions

export default processFirstContactNotification.reducer
